import { render, staticRenderFns } from "./TikTokAlt.vue?vue&type=template&id=1ad442ef&scoped=true&"
import script from "./TikTokAlt.vue?vue&type=script&lang=js&"
export * from "./TikTokAlt.vue?vue&type=script&lang=js&"
import style0 from "./TikTokAlt.vue?vue&type=style&index=0&id=1ad442ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad442ef",
  null
  
)

export default component.exports